"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var lodash_1 = require("lodash");
var skynet_store_utilities_1 = require("@synisys/skynet-store-utilities");
function cloneCategory(category) {
    return cloneEntity(category);
}
exports.cloneCategory = cloneCategory;
function cloneEntity(category) {
    return lodash_1.cloneDeepWith(category, function (value) {
        if (value instanceof idm_crosscutting_concepts_frontend_1.MultilingualString) {
            var cloneBuilder_1 = idm_crosscutting_concepts_frontend_1.MultilingualString.newBuilder();
            value.toMap().forEach(function (val, key) {
                cloneBuilder_1.withValueForLanguage(key, val);
            });
            return cloneBuilder_1.build();
        }
        else if (value) {
        }
    });
}
exports.cloneEntity = cloneEntity;
function createLogger(namespace) {
    return new skynet_store_utilities_1.Logger('skynet-store-kb-impl', namespace);
}
exports.createLogger = createLogger;
function makeValueObject(value, equals, hashCode) {
    var newValue = value;
    newValue.equals = function (other) {
        // tslint:disable-next-line:no-invalid-this
        return equals(this, other);
    };
    newValue.hashCode = function () {
        // tslint:disable-next-line:no-invalid-this
        return hashCode(this);
    };
    return newValue;
}
exports.makeValueObject = makeValueObject;
function toLower(str) {
    return lodash_1.isNil(str) ? str : str.toLowerCase();
}
exports.toLower = toLower;
//# sourceMappingURL=kb.utilities.js.map